import React from "react";
import styles from "./index.module.scss";
import { IDetailImg } from "../../../../../../types";
const Sidebar = ({ imageId, imageName, imagePath }: IDetailImg) => {
  return (
    <aside className={styles.aside}>
      <img src={imagePath} alt="" />
    </aside>
  );
};

export default Sidebar;
